export enum UpdateSetCardActionTypes {
  UPDATING = 'set-cards/UPDATING',
  UPDATED = 'set-cards/UPDATED',
}
